<template>
  <div class="w-100">
    <label>
      <b> {{ dayName }} </b> - Часы работы
    </label>

    <div class="d-flex">
      <div class="mr-2 mb-2 w-100">
        <label> Начало </label>
        <cleave
            id="start_time"
            v-model="form.start"
            class="form-control"
            :raw="false"
            :options="options.time"
            placeholder="hh:mm"
        />
      </div>
      <div class="w-100">
        <label> Конец </label>
        <cleave
            id="end_time"
            v-model="form.end"
            class="form-control"
            :raw="false"
            :options="options.time"
            placeholder="hh:mm"
        />
      </div>
    </div>

  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'

const {mapMutations} = createNamespacedHelpers('driverSchedule');

import Cleave from 'vue-cleave-component'
export default {
  name: "WorkingHoursInput",
  props: {
    dayName: String,
    dayId: Number | String,
    startTime: {
      default: ''
    },
    endTime: {
      default: ''
    }
  },
  components: {
    Cleave,
  },
  data() {
    return {
      form: {
        start: this.startTime,
        end: this.endTime
      },
      options: {
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
      }
    }
  },
}
</script>

<style scoped>

</style>
